import AuthGuard from "app/auth/AuthGuard";
import DefaultRedirect from "app/auth/DefaultRedirect";
import { MatxLayout } from "app/components";
import attendanceRoutes from "app/views/attendance/AttendanceRoutes";
import areaRoutes from "app/views/configuration/area/AreaRoutes";
import departmentRoutes from "app/views/configuration/department/DepartmentRoutes";
import designationRoutes from "app/views/configuration/designation/DesignationRoutes";
import dailyPlanRoutes from "app/views/configuration/dailyPlan/DailyPlanRoutes";
import feedTypeRoutes from "app/views/configuration/feedType/FeedTypeRoutes";
import monthlyPlanRoutes from "app/views/configuration/monthlyPlan/MonthlyPlanRoutes";
import territoryRoutes from "app/views/configuration/territory/TerritoryRoutes";
import tourPlanRoutes from "app/views/configuration/tourPlan/TourPlanRoutes";
import visitDayRoutes from "app/views/configuration/visitDay/VisitDayRoutes";
import zoneRoutes from "app/views/configuration/zone/ZoneRoutes";
import fishSpeciesRoutes from "app/views/configuration/fishSpecies/FishSpeciesRoutes";
import waterColourRoutes from "app/views/configuration/waterColour/WaterColourRoutes";
import tentativeDiagnosisRoutes from "app/views/configuration/tentativeDiagnosis/TentativeDiagnosisRoutes";
import companyRoutes from "app/views/configuration/company/CompanyRoutes";
import dashboardRoutes from "app/views/dashboard/DashboardRoutes";
import profileRoutes from "app/views/Profile/ProfileRoutes";
import dealerVisitRoutes from "app/views/DealerVisit/DealerVisitRoutes";
import coccidialStatusRoutes from "app/views/configuration/coccidialStatus/CoccidialStatusRoutes";
import farmManagementConditionRoutes from "app/views/configuration/farmManagementCondition/FarmManagementConditionRoutes";
import litterConditionRoutes from "app/views/configuration/litterCondition/LitterConditionRoutes";
import farmTypeRoutes from "app/views/FarmType/FarmTypeRoutes";
import farmCategoryRoutes from "app/views/FarmCategory/FarmCategoryRoutes";
import businessRelationRoutes from "app/views/BusinessRelation/BusinessRelationRoutes";
import strainOrBreedRoutes from "app/views/StrainOrBreed/StrainOrBreedRoutes";
import customerRoutes from "app/views/Customer/CustomerRoutes";
import customerTypeRoutes from "app/views/CustomerType/CustomerTypeRoutes";
import customerVisitRoutes from "app/views/CustomerVisit/CustomerVisitRoutes";
import farmVisitRoutes from "app/views/FarmVisit/FarmVisitRoutes";
import fishFarmVisitRoutes from "app/views/FishFarmVisit/FishFarmVisitRoutes";
import feedCompanyRoutes from "app/views/FeedCompany/FeedCompanyRoutes";
import medicineCompanyRoutes from "app/views/MedicineCompany/MedicineCompanyRoutes";
import chemistVisitRoutes from "app/views/ChemistVisit/ChemistVisitRoutes";
import marketingOfficerWiseFarmVisitRoutes from "app/views/MarketingOfficerWiseFarmVisit/MarketingOfficerWiseFarmVisitRoutes";
import fieldVisitKpiRoutes from "app/views/FieldVisitKpi/FieldVisitKpiRoutes";
import dailyFieldActivityRoutes from "app/views/DailyFieldActivity/DailyFieldActivityRoutes";
import roleRoutes from "app/views/Role/roleRoutes";
import AccessDenied from "app/views/sessions/AccessDenied";
import NotFound from "app/views/sessions/NotFound";
import sessionRoutes from "app/views/sessions/SessionRoutes";
import userRoutes from "app/views/User/user.route";
import workScheduleRoutes from "app/views/WorkSchedule/WorkScheduleRoutes";
import pondRoutes from "./views/configuration/pond/PondRoutes";
import employeeKpiSettingsRoutes from "app/views/configuration/employeeKpiSettings/EmployeeKpiSettingsRoutes";

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...dashboardRoutes,
      ...profileRoutes,
      { path: "/access-denied", element: <AccessDenied /> },
      ...dealerVisitRoutes,
      ...chemistVisitRoutes,
      ...userRoutes,
      ...roleRoutes,
      ...feedCompanyRoutes,
      ...medicineCompanyRoutes,
      ...farmTypeRoutes,
      ...farmCategoryRoutes,
      ...businessRelationRoutes,
      ...strainOrBreedRoutes,
      ...customerRoutes,
      ...customerTypeRoutes,
      ...coccidialStatusRoutes,
      ...farmManagementConditionRoutes,
      ...litterConditionRoutes,
      ...farmVisitRoutes,
      ...fishFarmVisitRoutes,
      ...customerVisitRoutes,
      ...marketingOfficerWiseFarmVisitRoutes,
      ...fieldVisitKpiRoutes,
      ...dailyFieldActivityRoutes,
      ...attendanceRoutes,
      ...departmentRoutes,
      ...designationRoutes,
      ...feedTypeRoutes,
      ...zoneRoutes,
      ...fishSpeciesRoutes,
      ...waterColourRoutes,
      ...tentativeDiagnosisRoutes,
      ...companyRoutes,
      ...tourPlanRoutes,
      ...monthlyPlanRoutes,
      ...dailyPlanRoutes,
      ...visitDayRoutes,
      ...areaRoutes,
      ...territoryRoutes,
      ...workScheduleRoutes,
      ...pondRoutes,
      ...employeeKpiSettingsRoutes,
    ],
  },
  ...sessionRoutes,
  { path: "/", element: <DefaultRedirect /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
